import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";

import { companyQueryKeys } from "./companyQueryKeys";

export default function useCompanyAttributesData(
  enabled: boolean = true,
  filter?: string,
) {
  const { appId, envId } = useEnvironment();
  return useQuery({
    queryKey: companyQueryKeys.attributes(appId, envId, filter),

    queryFn: () =>
      api
        .get<"/apps/:appId/company-attributes">(
          `/apps/${appId}/company-attributes`,
          {
            params: {
              filter,
              envId: envId!,
            },
          },
        )
        .then((res) => res.data.attributes),
    enabled: !!appId && !!envId && enabled,
  });
}
